import { Table } from '@ss/meta-core-components'
import React from 'react'
import styled from '@emotion/styled'
import { CorrelationCouple } from '@types'

interface Props {
  title: string
  tableData: CorrelationCouple[]
  dataCy: string
}

/**
 * Componente Contenente una tabella di correlazione
 * @param title {string} titolo della tabella
 * @param tableData {CorrelationCouple[]} dati da mostrare nella tabella
 * @param dataCy {string} selectro per cypress
 * @component
 */
export const CorrelationTable: React.FC<Props> = ({
  title,
  tableData,
  dataCy,
}) => {
  return (
    <TableWrapper data-cy={`${dataCy}-correlation-container`}>
      <Title data-cy={`${dataCy}-correlation-title`}>{title}</Title>
      <Table
        dataCy={`${dataCy}-correlation`}
        tableColumn={[
          { key: 'attributo_1', label: 'Attributo 1' },
          { key: 'attributo_2', label: 'Attributo 2' },
          { key: 'c_i', label: 'Correlation Index' },
        ]}
        data={tableData}
      />
    </TableWrapper>
  )
}

const TableWrapper = styled.div`
  width: 28%;
  margin-left: 2%;
  max-height: 600px;
  padding-top: 125px;
`
const Title = styled.p`
  color: white;
  font-size: 16px;
`
